var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4602 12.573C1.36908 12.5728 1.27898 12.5534 1.19564 12.516C1.11231 12.4786 1.03755 12.4239 0.976133 12.3556C0.913603 12.2879 0.865889 12.2075 0.836119 12.1197C0.80635 12.0319 0.795197 11.9387 0.803391 11.8463L0.96431 10.0503L8.39809 2.50762L10.7212 4.86495L3.28942 12.4069L1.51997 12.5703C1.5001 12.5721 1.48016 12.573 1.4602 12.573ZM11.1849 4.39362L8.86246 2.03628L10.2556 0.622282C10.3166 0.560298 10.389 0.511125 10.4687 0.477576C10.5485 0.444026 10.6339 0.426758 10.7202 0.426758C10.8066 0.426758 10.892 0.444026 10.9718 0.477576C11.0515 0.511125 11.1239 0.560298 11.1849 0.622282L12.578 2.03628C12.6391 2.0982 12.6875 2.17172 12.7206 2.25266C12.7537 2.33359 12.7707 2.42034 12.7707 2.50795C12.7707 2.59556 12.7537 2.68231 12.7206 2.76324C12.6875 2.84417 12.6391 2.9177 12.578 2.97962L11.1856 4.39295L11.1849 4.39362Z",
    fill: "#00A9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenicon);
export default __webpack_public_path__ + "static/media/penicon.a0b5a9b5dc3b080691479da91e9890c9.svg";
export { ForwardRef as ReactComponent };